import React, { useState, useEffect } from "react";
import ClassList from "../../components/ClassList";
import ClassOverview from "../../components/ClassOverview";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dialog from "../../components/Dialog/Dialog";

const Class = () => {
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [editClass, setEditClass] = useState(null);
  const [className, setClassName] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [dialog, setDialog] = useState({
    isOpen: false,
    type: "",
    title: "",
    message: "",
    onConfirm: null,
    onCancel: null,
  });

  useEffect(() => {
    fetchMockClasses();
  }, []);

  const fetchMockClasses = () => {
    const mockClasses = [
      { id: 1, className: "Nursery A" },
      { id: 2, className: "LKG B" },
      { id: 3, className: "UKG A" },
    ];
    setClasses(mockClasses);
  };

  const handleViewClass = (classData) => {
    setSelectedClass(classData);
  };

  const handleEditClass = (classData) => {
    setEditClass(classData);
    setClassName(classData.className);
  };

  const handleCancelEdit = () => {
    setEditClass(null);
    setClassName("");
  };

  const handleSave = () => {
    if (!className.trim()) {
      toast.error("Class name cannot be empty");
      return;
    }

    setIsProcessing(true);

    setTimeout(() => {
      if (editClass) {
        const updatedClasses = classes.map((c) =>
          c.id === editClass.id ? { ...c, className } : c
        );
        setClasses(updatedClasses);
        setSelectedClass({ ...editClass, className });
        toast.success("Class updated successfully.");
      } else {
        const newClass = {
          id: Date.now(),
          className,
        };
        setClasses([...classes, newClass]);
        toast.success("Class added successfully.");
      }

      setEditClass(null);
      setClassName("");
      setIsProcessing(false);
    }, 500); // simulate server delay
  };

  const handleDeleteClass = (classData) => {
    setDialog({
      isOpen: true,
      type: "confirm",
      title: "Confirm Deletion",
      message: `Are you sure you want to delete the class '${classData.className}'?`,
      onConfirm: () => confirmDeleteClass(classData),
      onCancel: () => setDialog({ ...dialog, isOpen: false }),
    });
  };

  const confirmDeleteClass = (classData) => {
    setDialog({ ...dialog, isOpen: false });
    setIsProcessing(true);

    setTimeout(() => {
      const updatedClasses = classes.filter((c) => c.id !== classData.id);
      setClasses(updatedClasses);
      if (selectedClass?.id === classData.id) {
        setSelectedClass(null);
      }
      toast.success("Class deleted successfully.");
      setIsProcessing(false);
    }, 500); // simulate delay
  };

  return (
    <div className="class-page">
      <div className="class-list-section">
        <ClassList classes={classes} onViewClass={handleViewClass} />
      </div>

      <div className="right-section">
        <div className="add-class-section">
          <h2>{editClass ? "Edit Class" : "Add New Class"}</h2>
          <div className="form-content">
            <div className="form-group">
              <label>Class Name</label>
              <input
                type="text"
                className="form-control"
                value={className}
                onChange={(e) => setClassName(e.target.value)}
                placeholder="Enter class name"
                disabled={isProcessing}
                required
              />
            </div>
            <div className="actions">
              {editClass ? (
                <>
                  <button
                    className="save-btn"
                    onClick={handleSave}
                    disabled={isProcessing}
                  >
                    {isProcessing ? "Saving..." : "Save Changes"}
                  </button>
                  <button
                    className="cancel-btn"
                    onClick={handleCancelEdit}
                    disabled={isProcessing}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <button
                  className="save-btn"
                  onClick={handleSave}
                  disabled={isProcessing}
                >
                  {isProcessing ? "Adding..." : "Add Class"}
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="overview-section">
          {selectedClass ? (
            <ClassOverview
              selectedClass={selectedClass}
              onEditClass={handleEditClass}
              onDeleteClass={handleDeleteClass}
            />
          ) : (
            <div className="empty-state">
              <div className="empty-icon">📚</div>
              <div className="empty-text">No Class Selected</div>
              <div className="empty-subtext">
                Select a class from the list to view details
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Dialog
        isOpen={dialog.isOpen}
        type={dialog.type}
        title={dialog.title}
        message={dialog.message}
        onConfirm={dialog.onConfirm}
        onCancel={dialog.onCancel}
      />
    </div>
  );
};

export default Class;
